import { RestSlice } from '../../../../../redux/rest.slice';
import { Frequency } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const settingLookupsFrequencySlice = new RestSlice<Frequency>(
	localizationService.getLocalizedString('cccSettings.frequencies'),
	`Settings/${Resource.Frequencies}`
);
export default settingLookupsFrequencySlice.rests.reducer;
